import type {Coverage} from '../shared/contracts';
// Compare editable coverage, independent of JSON key order, database rule order,
// generated ZIP coordinates, and harmless metres/miles round-trip precision.
export function coverageFingerprint(coverage:Coverage):string {
  return JSON.stringify({dataset:coverage.dataset,backupEnabled:coverage.backupEnabled,rules:coverage.rules.map(rule=>({
    id:rule.id,name:rule.name,effect:rule.effect,shape:rule.shape,enabled:rule.enabled,
    leadTypes:[...rule.leadTypes].sort(),zips:rule.shape==='zip_set'?[...new Set(rule.zips)].sort():[],
    centerZip:rule.shape==='radius'?rule.centerZip??null:null,
    radiusMiles:rule.shape==='radius'&&rule.radiusMiles!==undefined?Math.round(rule.radiusMiles*1e8)/1e8:null,
  })).sort((a,b)=>a.id.localeCompare(b.id))});
}
